import {StackScreenProps} from '@react-navigation/stack'
import I18n from 'i18n-js'
import {Observer, observer} from 'mobx-react'
import React, {useEffect} from 'react'
import {FlatList, View} from 'react-native'
import {Text} from 'react-native-elements'
import {
  Container,
  Content,
  ImageCard,
  ImageHeader,
  SubmitHeader,
  ToprLoader,
  ToprScreenLoader,
} from '../../../Components'
import {StockImageLayout} from '../../../Components/Web'
import {GetLocalizedImageUrl, GetRandomKey} from '../../../Helpers/UiHelpers'
import {appUiStore} from '../../../Mobx/AppUiStore'
import {MainScreensList} from '../../../Navigation'
import {myLog} from '../../../Services/Client/LogService'
import Style from '../../../Style'
import UserCouponsSummaryRow from './Components/UserCouponsSummaryRow'
import {userCouponSummaryStore} from './Store'

interface IProps
  extends StackScreenProps<MainScreensList, 'userCouponsSummary'> {}

const UserCouponsSummary: React.FC<IProps> = ({
  navigation: {goBack},
  route,
}) => {
  const {IsLoading, UserCouponSummaries, HasMoreLoading} =
    userCouponSummaryStore
  const couponSummary = route.params.couponSummary
  useEffect(() => {
    myLog.warn('CouponsSummary')
    userCouponSummaryStore.Initialize(couponSummary.Coupon.Guid)
  }, [null])

  const {
    defaultFlatListWhite,
    flatListContentStyleStock,
    flatListLoader,
    imageHeaderTitle,
  } = Style

  const renderFooter = () => {
    if (
      !userCouponSummaryStore.HasMoreLoading ||
      userCouponSummaryStore.IsLoading
    ) {
      return null
    }

    return (
      <View style={flatListLoader}>
        <ToprLoader size="small" isLoading={true} />
      </View>
    )
  }

  return (
    <>
      <Container keyboardAware={false}>
        <StockImageLayout
          imageUrl={GetLocalizedImageUrl(couponSummary.Coupon.Images[0].Guid)}
          padder={false}
          isLoading={IsLoading}>
          <Content headerMargin padder={false}>
            <FlatList
              style={defaultFlatListWhite}
              ListEmptyComponent={
                <ImageCard
                  imageUrl="https://images.unsplash.com/photo-1594968973184-9040a5a79963?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1050&q=80"
                  text={I18n.t('Dashboard.NoCoupons')}
                />
              }
              contentContainerStyle={flatListContentStyleStock}
              refreshing={HasMoreLoading}
              onEndReached={() => userCouponSummaryStore.NextPage()}
              onEndReachedThreshold={0.5}
              initialNumToRender={userCouponSummaryStore.Take}
              data={UserCouponSummaries}
              ListFooterComponent={() => {
                return <Observer>{() => renderFooter()}</Observer>
              }}
              onRefresh={() =>
                userCouponSummaryStore.Initialize(couponSummary.Coupon.Guid)
              }
              renderItem={({item}) => (
                <UserCouponsSummaryRow userCouponSummary={item} />
              )}
              keyExtractor={() => {
                return GetRandomKey()
              }}
            />
          </Content>
          <SubmitHeader onBackPress={goBack}>
            {couponSummary.Coupon.FullTitle}
          </SubmitHeader>
        </StockImageLayout>
      </Container>
    </>
  )
}
export default observer(UserCouponsSummary)
